import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import PurchaseProductDetail from "../../components/screen/purchaseOnlinePbf/PurchaseProductDetail";

const PurchaseProductDetailPbfPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <PurchaseProductDetail />
        </ThemeProvider>
      }
      pageRole={3}
      bgColor={"gray"}
      noPadding={true}
    />
  );
};

export default HOC(PurchaseProductDetailPbfPage);
